<template>
    <div class="edit-modal">
        <b-modal
            no-enforce-focus
            centered
            hide-footer
            id="modal-edit-event"
            size="xl"
            tabindex=""
            content-class="modal-edit-event"
        >
            <template #modal-header>
                <div class="close-modal-filter">
                    <p v-if="currentEvent.status >= 2" class="modal-title">Edit Event</p>
                    <p v-else class="modal-title">Edit Opportunity</p>
                    <div @click="$bvModal.hide('modal-edit-event')" class="cancel-btn">
                        <span>Cancel</span>
                        <img :src="getImage('close-event-modal-yellow.svg')" />
                    </div>
                </div>
            </template>
            <template v-if="currentEvent.status >= 2">
                <EditEventModal :event.sync="currentEvent" @action-completed="onComplete" />
            </template>
            <template v-else>
                <EditOpportunityModal :event="currentEvent" @action-completed="onComplete" />
            </template>
        </b-modal>
    </div>
</template>
<script>
    import { useAssets } from '@/composables/utils/useAssets'
    import EditEventModal from '@/components/ui/modals/EditEventModal.vue'
    import EditOpportunityModal from '@/components/ui/modals/EditOpportunityModal.vue'

    export default {
        name: 'EditModal',
        components: {
            EditEventModal,
            EditOpportunityModal
        },
        props: {
            currentEvent: {
                type: Object,
                required: true
            }
        },
        setup() {
            const { getImage } = useAssets()
            return {
                getImage
            }
        },
        methods: {
            onComplete() {
                window.location.reload()
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .close-modal-filter {
        display: flex;
        width: 100%;
        justify-content: space-between;
        .modal-title {
            color: $white;
            @include base-font-20;
            font-weight: 550;
            line-height: 120%;
        }
        .cancel-btn {
            color: $lime;
            @include base-font-16;
            line-height: 125%;
            display: flex;
            gap: 8px;
        }
    }
</style>
